import { cloneDeep } from 'lodash';
import { unset } from 'lodash';
import {
	Box,
	Button,
	FormHelperText,
	Link,
	Menu,
	Stack,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { get } from 'lodash';
import React, { FC, useEffect, useMemo, useState } from 'react';
import 'devextreme/dist/css/dx.dark.css';
// import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';
import deMessages from 'devextreme/localization/messages/de.json';
import { locale, loadMessages } from 'devextreme/localization';
import NachrichtFieldsValidator from './NachrichtFieldsValidator';
import { set } from 'lodash';
import LoadingBackdrop from '../loading/LoadingBackdrop';
import MuiSnackbar from '../mui-snackbar/MuiSnackbar';
import { NOT_FOUND_ERROR_MESSAGE } from '../../../lib/constants/constant';
import { APIS } from '../../../lib/constants/apis';
import { PostRecord } from '../../../lib/api/PostRecord';

import Schema from '../../../lib/paths/zuwendungsantrag_FULL_Paths.json';
import { getLocalstorageToken } from '../../../context/AuthHelper';
import CreateForm from '../form-component/create-form/CreateForm';
import { enumT } from '../../../utils/helper';

const P = Schema.attributes;

loadMessages(deMessages);
locale(navigator.language);

interface NachrichtFieldsProps {
	handleCloseDialog: () => void;
	applications: any[];
	setSendNachrichtSuccess: (value: boolean) => void;
	nachrichtId?: number;
	isReply?: boolean;
	originalTitle?: string;
	originalContent?: string;
}
const NachrichtFields: FC<NachrichtFieldsProps> = ({
	handleCloseDialog,
	applications,
	setSendNachrichtSuccess,
	nachrichtId,
	isReply,
	originalTitle,
	originalContent,
}) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [selectedApplication, setSelectedApplication] = useState<Record<string, any>>({});
	const [formValues, setFormValues] = useState<Record<string, any>>({});
	const [formErros, setFormErros] = useState<Record<string, any>>({});
	const [wsErrorMsg, setWsErrorMsg] = useState<string>('');
	const applicationLists = useMemo(() => {
		if (applications.length > 0) return applications;
		else return [];
	}, [applications]);

	const handleInputChange = (path: string, value: any) => {
		setFormValues((prevValue) => ({
			...prevValue,
			[path]: value,
		}));
		let errorObject = cloneDeep(formErros);
		unset(errorObject, path);
		setFormErros(errorObject);
	};

	const validateFormValues = () => {
		let errorObj = {};
		let errs = NachrichtFieldsValidator.validate(formValues);
		for (let error of errs) {
			set(errorObj, error.path, get(error, 'message', ''));
		}
		setFormErros(errorObj);
		return Object.keys(errorObj).length === 0;
	};

	const handleSendNachricht = async () => {
		if (validateFormValues()) {
			const data = {
				data: {
					...formValues,
					Allgemein_Ordner: 'Postausgang',
					Antragstellende: get(getLocalstorageToken(), 'organisationId'),
					Allgemein_Erstellt: new Date(),
				},
			};
			if (isReply) set(data, 'data.UrspruenglicheNachricht', nachrichtId);

			try {
				setLoading(true);
				const res = await PostRecord(APIS['Portal-Nachricht'], data);
				await PostRecord(APIS.PushNotificaiton, {
					data: { entities: [{ api: APIS['Portal-Nachricht'], id: get(res, 'data.id') }] },
				});
				if (res) setSendNachrichtSuccess(true);
			} catch (err: any) {
				console.error('ERROR Saving Nachrichten ', err);
				setWsErrorMsg(err.message);
			} finally {
				handleCloseDialog();
				setLoading(false);
			}
		}
	};

	useEffect(() => {
		if (applicationLists.length) {
			if (applicationLists.length === 1) {
				setSelectedApplication(applicationLists[0]);
			}
			// Setting Initial Values
			setFormValues(() => ({
				Zuwendungsantrag: applicationLists.length === 1 ? get(applicationLists[0], 'id') : null,
				Allgemein_Betreff: isReply ? `Re: ${originalTitle}` : '',
				Allgemein_Inhalt: originalContent
					? `${'\n\n---------------------------- Ursprügliche Nachricht ----------------------------\n' + originalContent}`
					: '',
			}));
		}
		setLoading(false);
	}, [applicationLists, isReply, originalContent, originalTitle]);

	console.log(' form value s ', formValues);

	if (loading) return <LoadingBackdrop />;
	return (
		<>
			<MuiSnackbar
				showSnackbar={Boolean(wsErrorMsg)}
				closeSnackbar={() => setWsErrorMsg('')}
				alertMessage={wsErrorMsg || NOT_FOUND_ERROR_MESSAGE}
				error={true}
			/>
			<Stack spacing={3}>
				<Box>
					<Link
						onClick={(e) => setAnchorEl(e.currentTarget)}
						sx={{
							cursor: 'pointer',
							display: 'inline-flex',
							alignContent: 'center',
							justifyContent: 'space-between',
							minWidth: '12.82rem',
							borderBottom: `${get(formErros, 'Zuwendungsantrag', false) ? '2px solid #d32f2f' : '2px solid'}`,
							color: `${get(formErros, 'Zuwendungsantrag', false) ? '2px solid #d32f2f' : null}`,
						}}
					>
						An:{' '}
						{get(selectedApplication, P.Allgemein_Projekttitel.path)
							? `[${get(selectedApplication, P.Allgemein_Projektnummer.path, 'ausstehend')}] ${get(selectedApplication, P.Allgemein_Projekttitel.path)}`
							: ''}
						{anchorEl ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
					</Link>
					{get(formErros, 'Zuwendungsantrag', false) && (
						<FormHelperText error>{get(formErros, 'Zuwendungsantrag')}</FormHelperText>
					)}

					<DropdownListApplication
						{...{ applicationLists, setSelectedApplication, handleInputChange, anchorEl, setAnchorEl }}
					/>
				</Box>

				<CreateForm
					formStruc={[
						{
							fields: [
								{ path: 'Allgemein_Betreff' },
								{ type: 'richtext', path: 'Allgemein_Inhalt', placeholder: 'Schreiben Sie hier Ihre Nachricht' },
							],
							userProps: { direction: 'column', columnToDivide: 1 },
						},
					]}
					formValues={formValues}
					updateFormValuesFunc={handleInputChange}
					formErrors={formErros}
				/>
				<Stack direction={'row'} justifyContent={'space-between'}>
					<Button variant={'outlined'} onClick={handleCloseDialog}>
						{' '}
						Abbrechen
					</Button>
					<Button onClick={handleSendNachricht}>Abschicken</Button>
				</Stack>
			</Stack>
		</>
	);
};
export default NachrichtFields;

interface DropdownListApplicationProps {
	applicationLists: any[];
	setSelectedApplication: (app: Record<string, any>) => void;
	handleInputChange: (path: string, value: any) => void;
	anchorEl: HTMLElement | null;
	setAnchorEl: (anchorEl: HTMLElement | null) => void;
}
const DropdownListApplication: FC<DropdownListApplicationProps> = ({
	applicationLists,
	setSelectedApplication,
	handleInputChange,
	anchorEl,
	setAnchorEl,
}) => {
	const handleApplicationSelect = (app: Record<string, any>) => {
		setSelectedApplication(app);
		handleInputChange('Zuwendungsantrag', get(app, 'id'));
		setAnchorEl(null);
	};
	return (
		<>
			<Menu
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={() => setAnchorEl(null)}
				MenuListProps={{
					'aria-labelledby': 'lock-button',
					role: 'listbox',
				}}
			>
				<TableContainer key={1}>
					<Table stickyHeader aria-label="sticky header table">
						<TableHead>
							<TableRow>
								<TableCell>Projektnummer</TableCell>
								<TableCell>Projekttitel</TableCell>
								<TableCell>Status</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{applicationLists.map((ele, i) => (
								<TableRow key={i} hover onClick={() => handleApplicationSelect(ele)}>
									<TableCell>{get(ele, P.Allgemein_Projektnummer.path)}</TableCell>
									<TableCell>{get(ele, P.Allgemein_Projekttitel.path)}</TableCell>
									<TableCell>{enumT(get(ele, P.Antragsstatus_Antragsstatus.path, ''))}</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Menu>
		</>
	);
};
